/**
 *
 * @export
 * @enum {string}
 */
export enum UserFunctionEnum {
  MENU_OPEN = "0000000",
  MENU_NEW_DOCUMENT = "0004231",
  MENU_IMPORT_DOCUMENT = "0004238",
  MENU_NEW_OBJECT = "0004240",
  MENU_EDIT_OBJECT = "0004241",
  MENU_SYNCHRONIZE = "0004246",
  MENU_UPDATE_PANEL_GET_CHANGES = "0004248",
  MENU_OBJECTLIST_PANEL_AVAILABLE_UPDATES = "0004243",
  MENU_OPEN_PANEL_MANAGE_TREE_STRUCTURE = "0004237",
  MENU_OUTLINE_PANEL_EDIT_DOCUMENT_PART = "0004233",
  MENU_OUTLINE_PANEL_EDIT_DOCUMENT_ROOT = "0004234",
  MENU_OUTLINE_PANEL_DUPLICATE_DOCUMENTS = "0004239",
  MENU_OUTLINE_PANEL_NEW_DOCUMENT_PART = "0004232",
  MENU_OUTLINE_PANEL_DELETE_DOCUMENT_PART = "0004236",
  MENU_OUTLINE_PANEL_UNLINK_DOCUMENT_PART = "0004249",
  MENU_OUTLINE_PANEL_DETACH_DOCUMENT_PART = "0004250",
  MENU_OPEN_PANEL_DBMAPPING = "0004251",
  MENU_MOVE_OBJECT = "0004264",
  MENU_LOCK_OBJECT = "0004265",
  MENU_IXBRL_ADMIN = "0004021",
  MENU_IXBRL_USER = "0004266",
}
